// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Left rail: the five palette triggers (Built-in, then the Node, Data, Agent
   and Model Catalogs), then Run all.
   Palette panels are absolutely positioned against this dock (see each
   palette's \`.panel\`), so they open in the strip to its right without
   stretching the rail. \`width: max-content\` keeps \`left: 100%\` on those
   panels anchored to the rail's own width.

   Deliberately NO \`overflow\` here: this dock is \`position: fixed\`, so it is the
   containing block for those absolute panels, and an overflow on it would clip
   them. The rail's height is capped on \`.builtinStack\` instead. */
.hXpGO4CLvTxandtvGCHJ {
    position: fixed;
    z-index: 100;
    top: 150px;
    left: 50px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: max-content;
    /* Let clicks pass through areas not covered by visible controls. */
    pointer-events: none;
}

/* Capped to the viewport so the rail cannot run past the fold. Nothing used to
   constrain it, so on a short screen the Run-all button at its foot was simply
   drawn off screen with no way to scroll to it - unreachable on a 1366x768
   laptop, which is ~660px of viewport after browser chrome.
   166px = the 150px \`top\` above plus 16px of breathing room.

   min-width keeps the cards at the 112px they had while the built-in tiles sat
   in the rail (two 45px tile columns, padding, border and the tiles' scrollbar).
   Fit View frames the canvas beside the rail's right edge, so the same width
   keeps every dataflow framed as before. */
.HcSZEcgHFFC87Be9KhJ4 {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    min-width: 112px;
    max-height: calc(100vh - 166px);
    pointer-events: none;
}

.HcSZEcgHFFC87Be9KhJ4 > * {
    pointer-events: auto;
}

/* flex-shrink: 0, as each palette root declares it, so the capped rail never
   compresses this row away. */
.r9xCwBbI4975ECnC2f8y {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  width: 100%;
  flex-shrink: 0;
}

.r9xCwBbI4975ECnC2f8y .cAD5B30NOBiBSepHMogQ {
  flex: 1 1 auto;
  justify-content: center;
  gap: 6px;
  padding: 6px 8px;
  border-radius: 5px;
  background-color: #1E1F23;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.fN57t8PZpzpi4CVmzPiW {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
  padding: 8px 0;
    background-color: #1E1F23;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 5px;
    color: #fbfcf6;
    font-size: 1.4em;
    cursor: pointer;
    transition: background-color 0.15s ease;
}

/* A run is in flight: the same button now cancels it (#271). */
.fN57t8PZpzpi4CVmzPiW[data-run-active="true"] {
  border-color: var(--curio-warning-text, #b7791f);
  color: var(--curio-warning-text, #b7791f);
}

/* #845: the dataflow runs its stale nodes on its own. */
.sMnyZjtuHWuF1b73sBl0 {
  align-self: flex-start;
  margin-left: 3px;
  font-size: 0.5em;
  color: #f5c451;
}

.fN57t8PZpzpi4CVmzPiW:hover {
    background-color: #2c2d32;
}

.fN57t8PZpzpi4CVmzPiW:active {
    background-color: #3a3b40;
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/nodes/ToolsMenu.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;kEASkE;AAClE;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,mEAAmE;IACnE,oBAAoB;AACxB;;AAEA;;;;;;;;;2CAS2C;AAC3C;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,gBAAgB;IAChB,+BAA+B;IAC/B,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;8BAC8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,cAAc;IACZ,yBAAyB;IACzB,2CAA2C;IAC3C,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,uCAAuC;AAC3C;;AAEA,+DAA+D;AAC/D;EACE,gDAAgD;EAChD,yCAAyC;AAC3C;;AAEA,wDAAwD;AACxD;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/* Left rail: the five palette triggers (Built-in, then the Node, Data, Agent\n   and Model Catalogs), then Run all.\n   Palette panels are absolutely positioned against this dock (see each\n   palette's `.panel`), so they open in the strip to its right without\n   stretching the rail. `width: max-content` keeps `left: 100%` on those\n   panels anchored to the rail's own width.\n\n   Deliberately NO `overflow` here: this dock is `position: fixed`, so it is the\n   containing block for those absolute panels, and an overflow on it would clip\n   them. The rail's height is capped on `.builtinStack` instead. */\n.paletteDock {\n    position: fixed;\n    z-index: 100;\n    top: 150px;\n    left: 50px;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    width: max-content;\n    /* Let clicks pass through areas not covered by visible controls. */\n    pointer-events: none;\n}\n\n/* Capped to the viewport so the rail cannot run past the fold. Nothing used to\n   constrain it, so on a short screen the Run-all button at its foot was simply\n   drawn off screen with no way to scroll to it - unreachable on a 1366x768\n   laptop, which is ~660px of viewport after browser chrome.\n   166px = the 150px `top` above plus 16px of breathing room.\n\n   min-width keeps the cards at the 112px they had while the built-in tiles sat\n   in the rail (two 45px tile columns, padding, border and the tiles' scrollbar).\n   Fit View frames the canvas beside the rail's right edge, so the same width\n   keeps every dataflow framed as before. */\n.builtinStack {\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 6px;\n    min-width: 112px;\n    max-height: calc(100vh - 166px);\n    pointer-events: none;\n}\n\n.builtinStack > * {\n    pointer-events: auto;\n}\n\n/* flex-shrink: 0, as each palette root declares it, so the capped rail never\n   compresses this row away. */\n.playAllRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.playAllRow .toolbar {\n  flex: 1 1 auto;\n  justify-content: center;\n  gap: 6px;\n  padding: 6px 8px;\n  border-radius: 5px;\n  background-color: #1E1F23;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.playAllButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 8px 0;\n    background-color: #1E1F23;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: 5px;\n    color: #fbfcf6;\n    font-size: 1.4em;\n    cursor: pointer;\n    transition: background-color 0.15s ease;\n}\n\n/* A run is in flight: the same button now cancels it (#271). */\n.playAllButton[data-run-active=\"true\"] {\n  border-color: var(--curio-warning-text, #b7791f);\n  color: var(--curio-warning-text, #b7791f);\n}\n\n/* #845: the dataflow runs its stale nodes on its own. */\n.autoRunBadge {\n  align-self: flex-start;\n  margin-left: 3px;\n  font-size: 0.5em;\n  color: #f5c451;\n}\n\n.playAllButton:hover {\n    background-color: #2c2d32;\n}\n\n.playAllButton:active {\n    background-color: #3a3b40;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paletteDock": `hXpGO4CLvTxandtvGCHJ`,
	"builtinStack": `HcSZEcgHFFC87Be9KhJ4`,
	"playAllRow": `r9xCwBbI4975ECnC2f8y`,
	"toolbar": `cAD5B30NOBiBSepHMogQ`,
	"playAllButton": `fN57t8PZpzpi4CVmzPiW`,
	"autoRunBadge": `sMnyZjtuHWuF1b73sBl0`
};
export default ___CSS_LOADER_EXPORT___;
